<!-- 随访奖金审阅配置 -->
<template>
  <div class="follow-up-bonus-review-setting">
    <v-btn-toggle v-model="toggle" color="blue" mandatory @change="getList">
      <v-btn width="100" height="35" :value="1">CRC奖金</v-btn>
      <v-btn width="100" height="35" :value="2">PM奖金</v-btn>
      <v-btn width="100" height="35" :value="3">小结奖金</v-btn>
      <v-btn width="100" height="35" :value="4">项目收入</v-btn>
    </v-btn-toggle>
    <div class="mt-2 mb-2">
      <v-btn
        color="primary"
        height="30"
        depressed
        variant="flat"
        @click="handleAdd"
        ><v-icon size="18">mdi-plus</v-icon>新增</v-btn
      >
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="pb-5 max-width header-grey"
      hide-default-footer
      no-data-text="暂无查询数据"
      disable-sort
      :loading="loading"
      loading-text="加载中..."
    >
      <template v-slot:item.operation="{ item }">
        <div class="flex-y-center">
          <a href="javascript:void(0)" @click="handleEdit(item)">编辑</a>
          <a
            href="javascript:void(0)"
            class="ml-3 red--text"
            @click="handleDelete(item)"
            >删除</a
          >
        </div>
      </template>
    </v-data-table>
    <div class="mt-2 pr-2 mb-5 max-width flex-justify-start">
      <pagination
        v-model="queryParams.pageNo"
        :size="queryParams.pageSize"
        :total="total"
        @changePageSize="(e) => ((queryParams.pageSize = e), getList())"
        @input="getList"
      />
    </div>
    <ReDialog :value.sync="showDialog" :title="title" @ok="handleSubmit">
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>审批顺序：
        </div>
        <form-item
          v-model="formData.approveSort"
          class="mr-0"
          placeholder="审批顺序"
          required
          type="text"
          @input="handleInputApproveSort"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>审批方式：
        </div>
        <form-item
          v-model="formData.approveType"
          class="mr-0"
          placeholder="审批方式"
          required
          type="select"
          :options="approvalTypes"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>项目角色/用户：
        </div>
        <form-item
          v-model="formData.configType"
          class="mr-0"
          placeholder="项目角色/用户"
          required
          type="select"
          :options="configTypes"
          @input="getApprovers"
        />
      </div>
      <div v-if="formData.configType" class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>
          {{ formData.configType == '1' ? '项目角色' : '用户' }}：
        </div>
        <form-item
          v-if="formData.configType == '1'"
          v-model="formData.configValue"
          class="mr-0"
          placeholder="项目角色"
          required
          type="select"
          :options="approvers"
        />
        <form-item
          v-else
          v-model="formData.configValues"
          class="mr-0"
          required
          type="select"
          placeholder="用户"
          :options="approvers"
          multiple
        />
      </div>
    </ReDialog>
  </div>
</template>

<script>
import ReDialog from '@/components/reDialog/index.vue';
export default {
  name: 'FollowUpBonusReviewSetting',
  components: {
    ReDialog,
  },
  data() {
    return {
      toggle: 1,
      tableHeaders: [
        {
          text: '审批顺序',
          value: 'approveSort',
          width: 50,
        },
        {
          text: '审批方式',
          value: 'approveTypeStr',
          width: 80,
        },
        {
          text: '项目角色/用户',
          value: 'configTypeStr',
          width: 150,
        },
        {
          text: '选项值',
          value: 'configName',
          width: 150,
        },
        {
          text: '操作',
          value: 'operation',
          width: 80,
        },
      ],
      tableItems: [],
      queryParams: {
        pageNo: 1,
        pageSize: 20,
      },
      total: 0,
      showDialog: false,
      title: '新增',
      formData: {
        configValue: '',
        configValues: [],
        bonusType: '', // CRC奖金/PM奖金/小结奖金
        approveSort: '',
        configType: '',
        approveType: '',
        id: '',
      },
      configTypes: [
        {
          text: '项目角色',
          value: '1',
        },
        {
          text: '用户',
          value: '2',
        },
      ],
      approvalTypes: [
        {
          text: '会签',
          value: '1',
        },
        {
          text: '或签',
          value: '2',
        },
      ],
      approvers: [],
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getApprovers(reset = true) {
      if (reset) {
        this.formData.configValue = '';
        this.formData.configValues = [];
      }

      if (this.formData.configType === '1') {
        this.$http
          .get(this.$api.roleListAll, {
            data: { roleCategory: 1 },
          })
          .then((res) => {
            if (res.result && res.result.length) {
              res.result.forEach((item) => {
                item.text = item.roleName;
                item.value = item.id;
              });
            }
            this.approvers = res.result || [];
          });
      } else {
        this.$http.get(this.$api.allUserList).then((res) => {
          this.approvers = [];
          Object.keys(res.result || {}).forEach((key) => {
            this.approvers.push({
              value: key,
              text: res.result[key],
            });
          });
        });
      }
    },
    getList() {
      this.loading = true;
      this.$http
        .get(this.$api.financialSettingList, {
          data: {
            filterType: this.toggle,
            ...this.queryParams,
          },
        })
        .then((res) => {
          if (res.result && res.result.records && res.result.records.length) {
            res.result.records.forEach((item) => {
              item.approveTypeStr = item.approveType === '1' ? '会签' : '或签';
              item.configTypeStr =
                item.configType === '1' ? '项目角色' : '用户';
            });
          }
          this.tableItems = res.result.records || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAdd() {
      this.formData = {
        configValue: '',
        bonusType: '', // CRC奖金/PM奖金/小结奖金
        approveSort: '',
        configType: '',
        approveType: '',
        id: '',
      };
      this.title = '新增';
      this.showDialog = true;
    },
    handleEdit(item) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = item[key];
      });
      if (this.formData.configType === '2') {
        this.formData.configValues = this.formData.configValue.split(',');
      }
      this.title = '编辑';
      this.showDialog = true;
      this.getApprovers(false);
    },
    handleSubmit() {
      const url = this.formData.id
        ? this.$api.updateFinancialSetting
        : this.$api.saveFinancialSetting;
      this.formData.bonusType = this.toggle;
      this.$http.post(url, { data: this.formData }).then((res) => {
        this.$message.success(res.message);
        this.showDialog = false;
        this.getList();
      });
    },
    handleDelete(item) {
      this.$confirm({
        text: '确定删除吗？',
      }).then((vm) => {
        this.$http
          .delete(this.$api.deleteFinancialSetting, {
            data: { id: item.id },
          })
          .then((res) => {
            vm.show = false;
            this.$message.success(res.message);
            this.getList();
          });
      });
    },
    handleInputApproveSort(e) {
      console.log(e);
      let num = '';
      if (e) {
        num = e.toString().replace(/\D/g, '');
        if (num > 99) {
          num = 99;
        }
        if (num < 0) {
          num = 0;
        }
      }

      this.formData.approveSort = num;
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-up-bonus-review-setting {
  padding: 20px;
}
.dialog-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__label {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
  }
}
</style>
